<template>
    <div id="routesTab">
      <div v-show="isLoadingmy " style="background: rgba(0,0,0,0.5);position: fixed;display: flex;justify-content:center;align-items:center;z-index: 1000001;left: 0;top: 0;height: 100%;width: 100%;">
            <img src="static/img/loader.gif" style="max-width:100px;"/>
      </div>
        <div class="scroll-list routeSectionWrapper">
            <md-list class="img-list check-avatar selectable">
              <draggable
              :list="routes"
              :disabled="!enabled"
              class="list-group"
              ghost-class="ghost"
              :move="checkMove"
              @update="onUpdate(routes)"
              @start="dragging = true"
              @end="endDragging(false)"
              title="Update sequence of routes"
             >
                    <md-list-item v-for="(route, index) in routes" :key="index" @click="navigateToTourRoute(route)" v-on:mouseover="toggleHoverOn(index)" v-on:mouseleave="toggleHoverLeave(index)">
                    <span v-if="route.activeInactiveImages === 1">
                        <img class="completeImages" src="static/img/complete.png">
                    </span>
                    <span v-else>
                        <img class="inCompleteImages" style="width :13px" src="static/img/inComplete.png">
                    </span>
                    <div role="button">
                        <div class="avatar s-36 material-icons">
                            <img :src="getImageSrc('route_default.png')"/>
                        </div>
                        <div class="md-list-item-text">
                            <h3>{{ route.name }}</h3>
                            <p>{{ route.description }}</p>
                        </div>
                        <md-menu class="upload-btn">
                            <md-button md-menu-trigger class="md-icon-button">
                                <md-icon>more_vert</md-icon>
                            </md-button>
                            <md-menu-content>
                                <md-menu-item class="md-list-item-text" style="cursor: pointer;" :disabled="clickedcopy" @click.once="addRouteAnotherTours(route.id, route.tourId,route.routeTopics,route.name,route.description, route.route_image, route.commentary,route.notificationSound,route.commentaryDelay,route.audioControllerNotification,route.audioControllerFlashTime,route.alt_path,route.headendSys,route.notificationSongId)">
                                    Copy Route To Tour
                                </md-menu-item>
                                <md-menu-item class="md-list-item-text" @click="confirmDelete(route.id)">
                                    Delete
                                </md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </div>
                    </md-list-item>
              </draggable>
            </md-list>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this Route?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="clickDelete(routeIdDelete)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDialogAllTours" style="overflow-y: scroll;">
            <md-list class="full-control">
                <md-subheader>TOURS</md-subheader>
                <md-list-item v-for="(tours, index) in arraytours" :key="index">
                    <md-radio v-model="toursIdForCopy" name="toursIdForCopy" class="radioButtonTours" :value="tours.id"/>
                    <span class="md-list-item-text">{{ tours.name }}</span>
                </md-list-item>
                <md-button class="ManualBtn ManualBtncancel" :disabled="onetimeRouteCopy" @click="addRouteAnotherToursModal(tempArray.routeID, tempArray.tourId, tempArray.routeTopics, tempArray.name, tempArray.description, tempArray.routeimage, tempArray.commentary, tempArray.notificationSound, tempArray.commentaryDelay, tempArray.audioControllerNotification, tempArray.audioControllerFlashTime, tempArray.altpath, tempArray.headendSys, tempArray.notificationSongId)">ADD Tours</md-button>
            </md-list>
        </md-dialog>
        <md-dialog :md-active.sync="arrayChannelModal" style="overflow-y: scroll;">
            <md-list class="full-control">
                <md-subheader>Channel</md-subheader>
                <md-list-item v-for="lang in arrayChannel" :key="lang.code">
                    <md-checkbox v-model="addLanguages" :value="lang.id" @change="somethingchannel($event,'channelsadd')">{{ lang.language }}</md-checkbox>
                </md-list-item>
                <md-button class="ManualBtn ManualBtncancel" v-if="ManageAddChannel" @click="addChannelAnotherToursModal(tempArrayChannel.routeID, tempArrayChannel.tourId, tempArrayChannel.routeTopics, tempArrayChannel.name, tempArrayChannel.description)">Save</md-button>
            </md-list>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="enableTourLanCheck">
            <md-dialog-title>
                Copy Error
            </md-dialog-title>
            <md-dialog-content>
                The Tour you are copying to has no languages assigned. Please add at least one
                language to the Tour within the Tour Settings page then try again
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogChannel">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="checkFileAnotherTours">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
                Please upload libary files for another tours (languages) in which you want to copy this route.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogChannelLibrary">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="checkRouteCompleteORnot">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
                Please Complete your Route .
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="checkRouteCompleteORnotOK">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import {mapState, mapActions, mapGetters} from 'vuex';
import {deleteRoute, getCopyName, adChannelIdToARoute} from '../../services/RouteService.js';
import {addToursCopyRoute, checkRouteIsComplete} from '../../services/ClientService.js';
import {getLanguageListWithRoute, checkRouteHasLanguage} from '../../services/LanguageService.js';

export default {
  components: {
    draggable: draggable
  },
  expand: {},
  data: () => ({
    routeIdDelete: [],
    showDeleteDialog: false,
    selectedRouteID: [],
    copyCount: 0,
    ManageAddChannel: false,
    deleteCount: 0,
    clickedcopy: false,
    onetimeRouteCopy: false,
    showDialogAllTours: false,
    arrayChannelModal: false,
    addLanguages: [],
    arraytours: [],
    arrayChannel: [],
    tempArray: [],
    ArrayinUse: [],
    isLoadingmy: false,
    toursIdForCopy: '',
    nameOfRoute: '',
    settings: {
      wifi: true,
      bluetooth: false
    },
    notification: ['sound', 'vibrate'],
    tempArrayChannel: [],
    checkRouteCompleteORnot: false
  }),
  computed: {
    ...mapState({
      routes: state => state.routes.routesList
    }),
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('tours', ['currentTour', 'currentTourDup', 'checkTourSettingSave']),
    ...mapGetters('routes', ['enableTourLanCheck', 'checkFileAnotherTours'])
  },
  methods: {
    ...mapActions('routes', ['loadEditorRoute', 'insertNewRoute', 'loadRoutes', 'routeCody', 'changeState', 'changeStateForFile', 'reorderTourRoutes']),
    ...mapActions('topics', ['cleanTopicsList']),
    ...mapActions('tours', ['funAgainSetCurrtTour']),
    confirmDelete (routeId) {
      this.showDeleteDialog = true;
      this.routeIdDelete = routeId;
    },
    onUpdate (routes) {
      this.isLoadingmy = true;
      this.savelistRouteOrder(routes);
    },
    async savelistRouteOrder (routes) {
      if (routes != null) {
        this.ArrayinUse = routes;
      }
      this.reorderTourRoutes({
        'clientId': this.currentClient.id,
        'tourId': this.currentTour.id,
        'newArray': this.ArrayinUse
      }).then(() => {
        this.isLoadingmy = false;
      });
    },

    toggleHoverOn (index) {
      this.routes[index].hover = true;
    },
    toggleHoverLeave (index) {
      this.routes[index].hover = false;
    },
    somethingchannel (event, defaultVal) {
      if (defaultVal === 'channelsadd') {
        this.ManageAddChannel = true;
      }
    },
    getImageSrc (image) {
      return 'static/img/' + image;
    },
    async showDeleteDialogChannel () {
      this.changeState(false);
    },
    async showDeleteDialogChannelLibrary () {
      this.changeStateForFile(false);
    },
    async checkRouteCompleteORnotOK () {
      this.checkRouteCompleteORnot = false;
    },
    endDragging (dragging) {
      dragging = false;
    },
    async addRouteAnotherTours (routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId) {
      const routeComplete = await checkRouteIsComplete(routeID, tourId);
      if (routeComplete.data === 0) {
        this.checkRouteCompleteORnot = true;
      } else {
        const response = await addToursCopyRoute(name);
        this.arraytours = response.data;
        this.tempArray['routeID'] = routeID;
        this.tempArray['tourId'] = tourId;
        this.tempArray['routeTopics'] = routeTopics;
        this.tempArray['name'] = name;
        this.tempArray['description'] = description;
        this.tempArray['route_image'] = routeimage;
        this.tempArray['commentary'] = commentary;
        this.tempArray['notificationSound'] = notificationSound;
        this.tempArray['commentaryDelay'] = commentaryDelay;
        this.tempArray['audioControllerNotification'] = audioControllerNotification;
        this.tempArray['audioControllerFlashTime'] = audioControllerFlashTime;
        this.tempArray['alt_path'] = altpath;
        this.tempArray['headendSys'] = headendSys;
        this.tempArray['notificationSongId'] = notificationSongId;
        this.showDialogAllTours = true;
      }
    },
    async addchannelToARoute (routeID, tourId, routeTopics, name, description, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, headendSys, notificationSongId) {
      const response = await getLanguageListWithRoute(tourId);
      const responsePertiRoute = await checkRouteHasLanguage(routeID);
      this.arrayChannel = response.data;
      var arrOfCurrentRoute = responsePertiRoute.data;
      if (arrOfCurrentRoute.length > 0) {
        for (let index = 0; index < arrOfCurrentRoute.length; index++) {
          const element = arrOfCurrentRoute[index];
          this.addLanguages.push(element);
        }
      } else {
        for (let index = 0; index < this.arrayChannel.length; index++) {
          const element = this.arrayChannel[index].id;
          this.addLanguages.push(element);
        }
      }
      this.tempArrayChannel['routeID'] = routeID;
      this.tempArrayChannel['tourId'] = tourId;
      this.tempArrayChannel['routeTopics'] = routeTopics;
      this.tempArrayChannel['name'] = name;
      this.tempArrayChannel['description'] = description;
      this.tempArrayChannel['commentary'] = commentary;
      this.tempArrayChannel['notificationSound'] = notificationSound;
      this.tempArrayChannel['commentaryDelay'] = commentaryDelay;
      this.tempArrayChannel['audioControllerNotification'] = audioControllerNotification;
      this.tempArrayChannel['audioControllerFlashTime'] = audioControllerFlashTime;
      this.tempArrayChannel['headendSys'] = headendSys;
      this.tempArrayChannel['notificationSongId'] = notificationSongId;
      this.arrayChannelModal = true;
    },
    async addRouteAnotherToursModal (routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId) {
      this.onetimeRouteCopy = true;
      this.copyAllTours(routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId, this.toursIdForCopy);
    },
    async addChannelAnotherToursModal (routeID, tourId, routeTopics, name, description) {
      await adChannelIdToARoute(routeID, this.addLanguages, tourId);
      this.loadRoutes(this.currentTour.id);
      this.ManageAddChannel = false;
      this.arrayChannelModal = false;
    },
    async copyAllTours (routeID, tourId, routeTopics, name, description, routeimage, commentary, notificationSound, commentaryDelay, audioControllerNotification, audioControllerFlashTime, altpath, headendSys, notificationSongId, toursIdForCopy = null) {
      if (this.clickedcopy === false) {
        this.clickedcopy = true;
        this.selectedRouteID.push(parseInt(routeID));
        const response = await getCopyName(name, routeID);
        if (toursIdForCopy === tourId) {
          this.nameOfRoute = response.data;
        } else {
          this.nameOfRoute = name;
        }
        var newRoute = {
          copyRoute: 1,
          name: this.nameOfRoute,
          parentrouteID: routeID,
          tourId: tourId,
          vehicleId: null, // this should default to something or be selectable somehow (?)
          description: description,
          route_image: routeimage,
          avatar: null,
          channels: null,
          path: null,
          alt_path: altpath,
          commentary: commentary,
          notificationSound: notificationSound,
          commentaryDelay: commentaryDelay,
          audioControllerNotification: audioControllerNotification,
          audioControllerFlashTime: audioControllerFlashTime,
          headendSys: headendSys,
          notificationSongId: notificationSongId,
          routeTopics: routeTopics,
          toursIdForCopy: toursIdForCopy
        };
        this.insertNewRoute(newRoute).then(() => {
          this.$router.push('/tour/topicRoutes/routes');
          if (toursIdForCopy) {
            this.showDialogAllTours = false;
            this.onetimeRouteCopy = false;
          }
        });
        this.clickedcopy = false;
      }
    },
    navigateToTourRoute (route) {
      if (this.checkTourSettingSave === false) {
        this.currentTour.defaultActivate = this.currentTourDup.defaultActivate;
        this.currentTour.defaultDelay = this.currentTourDup.defaultDelay;
        this.currentTour.defaultRadiusDistance = this.currentTourDup.defaultRadiusDistance;
        this.currentTour.defaultTolerance = this.currentTourDup.defaultTolerance;
        this.funAgainSetCurrtTour(this.currentTour);
      }
      this.loadEditorRoute(route);
      this.$router.push('/tour/route');
    },
    async clickDelete (routeId) {
      const response = await deleteRoute(routeId);
      for (let index = 0; index < this.selectedRouteID.length; index++) {
        const element = this.selectedRouteID[index];
        if (element === parseInt(routeId)) {
          if (this.deleteCount === 0) {
            this.selectedRouteID.splice(index, 1);
          }
          this.deleteCount++;
        }
      }

      if (response.status === 200) {
        this.loadRoutes(this.currentTour.id);
        this.showDeleteDialog = false;
        this.routeIdDelete = [];
      }
    }
  },
  mounted () {
    if (this.checkTourSettingSave === false) {
      this.currentTour.defaultActivate = this.currentTourDup.defaultActivate;
      this.currentTour.defaultDelay = this.currentTourDup.defaultDelay;
      this.currentTour.defaultRadiusDistance = this.currentTourDup.defaultRadiusDistance;
      this.currentTour.defaultTolerance = this.currentTourDup.defaultTolerance;
      this.funAgainSetCurrtTour(this.currentTour);
    }
  }
};
</script>
<style lang="scss">

.md-radio.md-theme-default.md-checked .md-radio-container:after {
    background-color: #00A8CA !important;
}

.aside-wrapper {
    .md-menu-item .md-list-item-button {
        font-size: 14px !important;
        font-weight: 400;
        margin: 0 !important;
        line-height: 36px !important;
        text-align: left;
        text-transform: none;
        width: 100%;
        padding: 0px 16px;
    }
}

.md-radio.md-theme-default.md-checked .md-radio-container {
    border-color: #00A8CA !important;
}

#routesTab .scroll-list {
    position: absolute;
    top: 240px;
    bottom: 10px;
    left: 0;
    right: 0;
    overflow: auto;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.completeImages {
    width: 14px;
    margin-right: 10px;
}

.scroll-list.routeSectionWrapper .md-ripple.md-list-item-content {
    justify-content: normal;
}

.scroll-list.routeSectionWrapper .md-ripple.md-list-item-content > span {
    padding-left: 40px;
}

.scroll-list.routeSectionWrapper .TopicRoutesContainer .md-list-item-text {
    width: auto;
}

.full-control > .md-list {
    width: 320px;
    max-width: 100%;
    height: 400px;
    display: inline-block;
    overflow: auto;
    border: 1px solid rgba(#000, .12);
    vertical-align: top;
}

.md-list-item-text p {
    overflow-wrap: break-word;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/RoutesTab.vue